const interceptImgSrc = () => {
  const originalDescriptor = Object.getOwnPropertyDescriptor(
    HTMLImageElement.prototype,
    'src'
  );

  Object.defineProperty(HTMLImageElement.prototype, 'src', {
    get() {
      return originalDescriptor?.get?.call(this);
    },
    async set(url) {
      // 在这里处理图片 URL
      // https://images-erp.sursung.com/prod/erp/Item/10389470/20250718/A8CE6C60B877447093C86F05E8AFB1F0.png?name=1752848891655.png
      if (!url || url.indexOf('images-erp.sursung.com') === -1) {
        return originalDescriptor?.set?.call(this, url);
      }
      try {
        const response = await fetch(url, {
          mode: 'cors',
          referrerPolicy: 'no-referrer',
        });
        const blob = await response.blob();

        const base64Img = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        return originalDescriptor?.set?.call(this, base64Img);
      } catch (error) {
        return originalDescriptor?.set?.call(this, url);
      }
    },
  });
};

interceptImgSrc();

export default interceptImgSrc;
